module.exports = __webpack_public_path__ + "static/media/carrot-dropdown.f9915e14.svg";